import { useEffect } from "react";

export const useOnEnter = (callback: VoidFunction) => useOnKeyUp(callback, "Enter");
export const useOnEscape = (callback: VoidFunction) => useOnKeyUp(callback, "Escape");

const useOnKeyUp = (callback: VoidFunction, key: string) => {
    useEffect(() => {
        const onKeyUp = (event: KeyboardEvent) => {
            const { key: keyPressed } = event;
            if (keyPressed !== key) {
                return;
            }
            callback();
        };
        document.body.addEventListener("keyup", onKeyUp);
        return () => {
            document.body.removeEventListener("keyup", onKeyUp);
        };
    }, [callback]);
};
